module.exports = __webpack_public_path__ + "img/sld_vcb_ta1_noarrow.429a9406.svg";